import badam from '../login page/hom1/dryfruit/badam.jpg'
import pista from '../login page/hom1/dryfruit/pista.jpg'
import kaju from '../login page/hom1/dryfruit/kaju.jpg'
import dryfig from '../login page/hom1/dryfruit/dryfig.jpg'
import blackgrapes from '../login page/hom1/dryfruit/blackgrapes.jpg'
import greengrapes from '../login page/hom1/dryfruit/greengrapes.jpg'
import coconut from '../login page/hom1/dryfruit/coconut.jpg'
import sunflowerseed from '../login page/hom1/dryfruit/sunflowerseed.jpeg'
import surapi from '../login page/hom1/dryfruit/surapi.jpg'
import khajur from '../login page/hom1/dryfruit/khajur.jpg'
import akharot from '../login page/hom1/dryfruit/akharot.jpg' 
import dryberries from '../login page/hom1/dryfruit/dryberries.jpg'
import poinenuts from '../login page/hom1/dryfruit/poinenuts.jpg'
import apricot from '../login page/hom1/dryfruit/apricot.jpg'
import dryblackbarry from '../login page/hom1/dryfruit/dryblackbarry.jpg'
import hazelnuts from '../login page/hom1/dryfruit/hazelnuts.jpg'
import wishlist1 from '../login page/hom1/wishlist1.jpg'
import wishlist2 from '../login page/hom1/wishlist2.jpg'
const Ddata = [
    {
        sname: "badam",
        imgscr: badam,
        title: "real veg",
        price: "50/-KG",
        oldprice1: "150/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2,
    },
    {
        sname: "pista",
        imgscr: pista,
        title: "real veg",
        price: "100/-KG",
        oldprice1: "200/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "kaju",
        imgscr: kaju,
        title: "real veg",
        price: "250/-KG",
        oldprice1: "400/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "dryfig",
        imgscr: dryfig,
        title: "real veg",
        price: "250/-KG",
        oldprice1: "500/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "blackgrapes",
        imgscr: blackgrapes,
        title: "real veg",
        price: "350/-KG",
        oldprice1: "400/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "greengrapes",
        imgscr: greengrapes,
        title: "real veg",
        price: "450/-KG",
        oldprice1: "600/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "coconut",
        imgscr: coconut,
        title: "real veg",
        price: "150/-KG",
        oldprice1: "200/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "sunflowerseed",
        imgscr: sunflowerseed,
        title: "real veg",
        price: "250/-KG",
        oldprice1: "300/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "surapi",
        imgscr: surapi,
        title: "real veg",
        price: "350/-KG",
        oldprice1: "400/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "khajur",
        imgscr: khajur,
        title: "real veg",
        price: "450/-KG",
        oldprice1: "500/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "akharot",
        imgscr: akharot,
        title: "real veg",
        price: "550/-KG",
        oldprice1: "600/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "dryberries",
        imgscr: dryberries,
        title: "real veg",
        price: "650/-KG",
        oldprice1: "800/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "poinenuts",
        imgscr: poinenuts,
        title: "real veg",
        price: "750/-KG",
        oldprice1: "900/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "dryblackbarry",
        imgscr: dryblackbarry,
        title: "real veg",
        price: "950/-KG",
        oldprice1: "1100/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "hazelnuts",
        imgscr: hazelnuts,
        title: "real veg",
        price: "1250/-KG",
        oldprice1: "1500/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "apricot",
        imgscr: apricot,
        title: "real veg",
        price: "300/-KG",
        oldprice1: "600/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
]
export default Ddata